import {safeGetStore} from '../store/store';

const getActiveRoles = () => {
    return safeGetStore().user.roles;
};

const userIsStaff = () => {
    let roles = getActiveRoles();

    return !!(roles && roles.staff && roles.staff.length > 0);
};

const userHasRole = (roleDomain, roleName) => {
    let roles = getActiveRoles();

    // only continue searching if the domain exists
    if (typeof roles !== 'undefined' && roles !== null && roles.hasOwnProperty(roleDomain)) {
        let domainRoles = roles[roleDomain];

        for (let i in domainRoles) {
            if (domainRoles[i] === roleName) {
                return true;
            }
        }
    }

    // if we get here, no roles matched the query
    return false;
};

export {
    getActiveRoles,
    userIsStaff,
    userHasRole,
};
